export const columns = function () {
    return [
        {
            prop: 'id',
            label: 'ID',
            width: '180',
        },
        {
            prop: 'company',
            label: '报价公司',
            minWidth: 100,
        },
        {
            prop: 'company_logo',
            label: 'logo',
            minWidth: 150,
        },
        {
            prop: 'company_watermark',
            label: '水印',
            minWidth: 150,
        },
        {
            prop: 'official_seal',
            label: '公章',
        },
        {
            prop: 'handle',
            label: '操作',
            fixed: 'right',
        }
    ]
}

export default {}